import React from 'react';
import { connect } from 'react-redux';
import isEqual from 'lodash.isequal';

// Actions
import { setFinalForm } from 'services/finalForms/actions';

interface Props {
    namespace: string;
    formProps: {};
    setFinalForm: Function;
}

export class FormStateToRedux extends React.Component<Props> {
    componentDidMount() {
        const { namespace, formProps, ...props } = this.props;
        props.setFinalForm(namespace, formProps);
    }

    componentDidUpdate(prevProps: Props) {
        const { namespace, formProps, ...props } = this.props;

        if (!isEqual(prevProps.formProps, formProps)) {
            props.setFinalForm(namespace, formProps);
        }
    }

    componentWillUnmount() {
        const { namespace, ...props } = this.props;
        props.setFinalForm(namespace, null);
    }

    render() {
        return null;
    }
}

export default connect(
    null,
    { setFinalForm }
)(FormStateToRedux);
